module.exports = __webpack_public_path__ + "img/img_10.1aeb7735.png";